import { visT } from "views/components/visualizations/visualizationTranslation";
import NetworkGraphVisualization from "views/components/visualizations/network/NetworkGraphVisualization";
import NetworkVisualizationConfig, {
  COLORSCALES
} from "views/logic/aggregationbuilder/visualizations/NetworkVisualizationConfig";
import { defaultCompare } from "logic/DefaultCompare";
const countGroupingFields = (formValues) => {
  var _a, _b;
  return ((_b = (_a = formValues.groupBy) == null ? void 0 : _a.groupings) != null ? _b : []).reduce((total, grouping) => {
    var _a2, _b2;
    return total + ((_b2 = (_a2 = grouping.fields) == null ? void 0 : _a2.length) != null ? _b2 : 0);
  }, 0);
};
const validate = (formValues) => {
  if (countGroupingFields(formValues) < 2) {
    return { type: visT("vis_validation.network_requires_groupings") };
  }
  return {};
};
const networkGraph = {
  type: NetworkGraphVisualization.type,
  get displayName() {
    return visT("vis_types.network_graph");
  },
  component: NetworkGraphVisualization,
  config: {
    fromConfig: (config = NetworkVisualizationConfig.empty()) => ({
      colorScale: config.colorScale,
      reverseScale: config.reverseScale
    }),
    toConfig: ({ colorScale, reverseScale = false }) => NetworkVisualizationConfig.create(colorScale, reverseScale),
    createConfig: () => ({ colorScale: "YlOrRd", reverseScale: false }),
    fields: [
      {
        name: "colorScale",
        get title() {
          return visT("vis_common.color_scale");
        },
        required: true,
        type: "select",
        options: [...COLORSCALES].sort(defaultCompare)
      },
      {
        name: "reverseScale",
        type: "boolean",
        get title() {
          return visT("vis_common.reverse_scale");
        }
      }
    ]
  },
  validate
};
export default networkGraph;
